import React from 'react';

interface LogoProps {
  /** Pixel size of the square mark. */
  size?: number;
  /** Render the "Parnasa Apps" wordmark next to the mark. */
  withWordmark?: boolean;
  className?: string;
}

/**
 * The Parnasa mark, redrawn as vector so it stays crisp at every size and can
 * carry the brand gradient. Geometry follows the original logotype: a
 * three-quarter disc closed off by a square foot, with a punched counter.
 */
const Logo: React.FC<LogoProps> = ({ size = 34, withWordmark = true, className = '' }) => {
  const gradientId = React.useId();

  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 200 200"
        role="img"
        aria-label="Parnasa Apps"
        className="shrink-0"
      >
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#b3bcf7" />
            <stop offset="55%" stopColor="#8b9af0" />
            <stop offset="100%" stopColor="#bf91dc" />
          </linearGradient>
        </defs>
        <path d="M44 96a56 56 0 1 1 56 56H44z" fill={`url(#${gradientId})`} />
        <circle cx="100" cy="96" r="19" fill="#0a0b10" />
      </svg>
      {withWordmark && (
        <span className="flex items-baseline gap-1.5 leading-none">
          <span className="font-display text-[21px] tracking-tight text-paper">Parnasa</span>
          <span className="font-mono text-[9.5px] uppercase tracking-label text-peri-400">Apps</span>
        </span>
      )}
    </span>
  );
};

export default Logo;
